export const MAX_ZOOM = 19;
